/**
 * EngineAuditPage — Routed page for the Engine Audit panel.
 *
 * Route: /engine-audit/:reportId
 * Registered in toolsManifest.ts with capability 'engine-audit', surface 'engine-audit-panel'
 *
 * Phase 1.3 — Engine Audit Panel (redesign-p1-1.3-engine-audit-panel)
 */

import React from 'react';
import { useParams } from 'react-router-dom';
import { EngineAuditPanel } from '@/components/EngineAuditPanel';
import { BRAND_NAME } from '@/config/brand';

export function EngineAuditPage() {
  const { reportId } = useParams<{ reportId: string }>();

  if (!reportId) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[var(--color-bg-base)]">
        <div className="text-center">
          <h1 className="text-xl font-semibold text-[var(--color-text-primary)]">
            Report ID Required
          </h1>
          <p className="mt-2 text-sm text-[var(--color-text-muted)]">
            Please provide a valid case/report ID to view the engine audit.
          </p>
        </div>
      </div>
    );
  }

  // Update document title
  React.useEffect(() => {
    document.title = `Engine Audit — ${BRAND_NAME}`;
  }, []);

  return (
    <div className="min-h-screen bg-[var(--color-bg-base)] p-6">
      <div className="mx-auto max-w-7xl">
        <EngineAuditPanel reportId={reportId} />
      </div>
    </div>
  );
}

export default EngineAuditPage;
